import React from "react";
import { InputAdornment, SvgIcon, TextField } from "@mui/material";
import { colors } from "common";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { SearchButton } from "components/SearchButton";

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      backgroundColor: colors.white,
    },
    input: {
      "& label.Mui-focused": {
        color: colors.primary,
      },
      "& .MuiInput-underline:after": {
        borderBottomColor: colors.primary,
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: colors.grey[300],
        },
        "&:hover fieldset": {
          borderColor: colors.primary,
        },
        "&.Mui-focused fieldset": {
          borderColor: colors.primary,
        },
      },
    },
  }),
  { index: 999 }
);

const component = ({ onChangeKeyword, value, searchBuild }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const classes = useStyles();

  const onEnter = () => {
    searchBuild();
  };

  const onClear = () => {
    const mockedEvent = { target: { value: "" } };
    onChangeKeyword(mockedEvent);
  };

  return (
    <div className={classes.root}>
      <TextField
        fullWidth
        size="small"
        onKeyPress={(event) => {
          if (event.key === "Enter") {
            onEnter();
          }
        }}
        value={value}
        onChange={onChangeKeyword}
        className={classes.input}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SvgIcon fontSize="small" color="action">
                <SearchIcon />
              </SvgIcon>
            </InputAdornment>
          ),
          endAdornment: <SearchButton onEnter={onEnter} onClear={onClear} />,
        }}
        placeholder="Search Build"
        variant="outlined"
      />
    </div>
  );
};

export const BuildsGallerySearchBar = React.memo(component);

// BuildsGallerySearchBar.propTypes = {
//   onChangeKeyword: PropTypes.func,
//   value: PropTypes.string,
// };
